import Backbone from 'backbone';
import { EmptyObject } from '@ve/types/EmptyObject';

export interface BlockParams {
    block: boolean;
}

export function block(tourCriteria: Backbone.Model): BlockParams | EmptyObject {
    let tourCriteriaJson: BlockParams | EmptyObject = {};
    const element: boolean = tourCriteria.get('block');
    if (element) {
        tourCriteriaJson = {
            block: true,
        };
    }
    return tourCriteriaJson;
}